import { get } from 'lodash';
import { validateLanguage } from './validate-language';

export const getCurrentSiteLanguage = (wixCodeApi) => {
  return validateLanguage(getMultilingualLanguage(wixCodeApi) || wixCodeApi.site.language);
};

export const getMultilingualLanguage = (wixCodeApi) => get(wixCodeApi, 'window.multilingual.currentLanguage');
